module.exports = __webpack_public_path__ + "static/media/David.5fd5c81a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/David.jpg
// module id = 1741
// module chunks = 146